/**
 * @generated SignedSource<<b43aea3df0070210fcec15ec8cb9c50b>>
 * @relayHash 105992711dc201bcdc02eab95a31be75
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 581380d480b1c1aef14b326950f927e04ff260333f2aa183ddfcaf75fa5bb07c

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type AccessType = "EDIT" | "VIEW" | "%future added value";
export type RequestPageAccessInput = {
  accessType: AccessType;
  pageId: string;
};
export type useRequestToEditContentRequestPageAccessMutation$variables = {
  requestPageAccessInput: RequestPageAccessInput;
};
export type useRequestToEditContentRequestPageAccessMutation$data = {
  readonly requestPageAccess: {
    readonly displayName: string;
  } | null | undefined;
};
export type useRequestToEditContentRequestPageAccessMutation = {
  response: useRequestToEditContentRequestPageAccessMutation$data;
  variables: useRequestToEditContentRequestPageAccessMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "requestPageAccessInput"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "requestPageAccessInput",
        "variableName": "requestPageAccessInput"
      }
    ],
    "concreteType": "RequestPageAccessPayload",
    "kind": "LinkedField",
    "name": "requestPageAccess",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "displayName"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useRequestToEditContentRequestPageAccessMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRequestToEditContentRequestPageAccessMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "105992711dc201bcdc02eab95a31be75",
    "id": "581380d480b1c1aef14b326950f927e04ff260333f2aa183ddfcaf75fa5bb07c",
    "metadata": {},
    "name": "useRequestToEditContentRequestPageAccessMutation",
    "operationKind": "mutation",
    "text": "mutation useRequestToEditContentRequestPageAccessMutation($requestPageAccessInput:RequestPageAccessInput!){requestPageAccess(requestPageAccessInput:$requestPageAccessInput){displayName}}"
  }
};
})();

(node as any).hash = "5e921684206067f4b8976995c29ac184";

export default node;
